import firebase from 'firebase/app';
import { JoyField } from 'joy-core';
export default class FirebaseAuthListener {
    constructor(action) {
        this.action = action;
        this.unSubscribe = null;
    }
    activate() {
        if (this.unSubscribe !== null) {
            return;
        }
        this.unSubscribe = firebase.auth().onAuthStateChanged((user) => {
            let data = new Map();
            data[JoyField.auth] = Boolean(user);
            if (Boolean(user)) {
                data[JoyField.user] = user.uid;
            }
            this.action(data);
        }, (error) => {
            console.log(`Encountered state observer error: ${error}`);
        });
    }
    deactivate() {
        this.unSubscribe();
        this.unSubscribe = null;
    }
}
//# sourceMappingURL=FirebaseAuthListener.js.map